import React from 'react';
import { ActivityIndicator, StyleSheet, View } from 'react-native';
import Gstyles from '../global/styles';

const Loading = () => {
    return (
        <View style={styles.container}>
            <ActivityIndicator animating={true} size={'large'}/>
        </View>
    );
};

const styles = StyleSheet.create({
    container: {
        alignItems:'center', 
        justifyContent:'center', 
        flex:1, 
        ...Gstyles.rootContainer,
    }
});

export default Loading;